interface ErrorBannerProps {
  message: string;
  entityName?: string; // e.g., "projects" or "employees"
}

export function ErrorBanner({
  message,
  entityName = "data",
}: ErrorBannerProps) {
  return (
    <div className="error-banner">
      <span>Unable to load {entityName}</span>
      <span className="error-banner__message">{message}</span>
    </div>
  );
}
